import { observable, computed, action, makeObservable, override } from 'mobx';

import { List } from './List';

export abstract class LongList<ListParams, CreateParams, FilterParams = null, I = string> extends List<
    ListParams,
    CreateParams,
    FilterParams,
    I
> {
    @observable public count = 0;
    @observable public offset = 0;

    public readonly limit: number = 100;

    constructor(params?: CreateParams[]) {
        super(params);
        makeObservable(this);
    }

    @computed
    public get queryParams(): { limit: number; offset: number } {
        return {
            limit: this.limit,
            offset: this.offset,
        };
    }

    @computed
    public get hasNext(): boolean {
        return this.offset < this.count;
    }

    @computed
    public get needLoadMore(): boolean {
        return this.offset === 0 || this.offset < this.count;
    }

    @override
    public add(params: CreateParams[]): void {
        super.add(params);
    }

    @override
    public reset(): void {
        super.reset();
        this.count = 0;
        this.offset = 0;
    }

    @override
    public set(params: CreateParams[]): void {
        super.set(params);

        this.offset = params.length !== 0 ? this.limit : 0;
    }

    @action
    public addNext(params: CreateParams[]): void {
        this.add(params);

        this.offset = this.offset + this.limit;
    }

    public needLoadNext(targetOffset: number): boolean {
        return !targetOffset || this.offset < targetOffset;
    }
}
